<template>
  <div class="successful-view" :class="{ 'is-tabletpc': !isMobile }">
    <bf-row :gutter="24" type="flex" align="middle" justify="center">
      <bf-col :span="20" :mobile="24">
        <bf-row class="justify-content-center" type="flex" justify="center" align="middle">
          <!-- begin::Right Layout Component -->
          <bf-col :span="24" :mobile="24">
            <!--begin::Box-->
            <bf-row
              type="flex"
              align="middle"
              :class="className"
            >
              <div
                v-if="icon"
                class="d-flex box-label justify-content-center"
              >
                <img :alt="`icon ${icon}`" :src="icon" />
              </div>
              <div class="box-content w-100 text-white text-center">
                <div>
                  <div
                    class="block text-3xl text-bold mb-xs text-white"
                    >{{ title }}
                  </div>
                </div>
                <!-- Slot content -->
                <p>{{ $t('lunaNewYear.text1') }}</p>
                <i18n
                  path="lunaNewYear.text2"
                  tag="p"
                >
                  <strong slot="newYear" class="mg-inline">
                    {{ $t('lunaNewYear.newYear') }}
                  </strong>
                </i18n>
                <i18n
                  path="lunaNewYear.text3"
                  tag="p"
                >
                  <a
                    slot="eventHotline"
                    class="mg-inline"
                    :href="`tel: ${$t('lunaNewYear.eventHotline')}`"
                    style="color: #fff"
                  >
                    <strong>
                      {{ $t('lunaNewYear.eventHotline') }}
                    </strong>
                  </a>
                </i18n>
                <p>{{ $t('lunaNewYear.text4') }}</p>
                <i18n
                  path="lunaNewYear.eventTextLink"
                  tag="p"
                >
                  <a
                    slot="labelLink"
                    :href="linkEvent"
                    target="_blank"
                    class="text-decoration-underline"
                    style="color: #fff"
                  >
                    <strong>
                      {{ $t('lunaNewYear.labelLink') }}
                    </strong>
                  </a>
                </i18n>
                <bf-link slot="link" underline>
                  <a :href="redirectUrl" style="color: #3FDDFE">
                    <bf-button
                      class="button-padding"
                      tertiary
                      type="primary"
                    >
                      <i18n
                        path="lunaNewYear.autoGotoDashboard"
                        tag="span"
                      >
                        <strong slot="time">{{ timer }}</strong>
                        <strong slot="unit">
                          {{ 's' }}
                          <bf-icon class="inline-icon" name="arrow-forward" />
                        </strong>
                      </i18n>
                    </bf-button>
                  </a>
                </bf-link>
                <!-- End slot content -->
              </div>
              <!-- /text-content -->
            </bf-row>
            <!--end::Symbol-->
          </bf-col>
          <!-- end::Right Layout Component -->
        </bf-row>
      </bf-col>
    </bf-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import successful from '@/assets/icons/icon-successful.svg';
import { DASHBOARD } from '@/config/urls';
import { addSearchParams } from '@/utils/common';

export default {
  name: 'SuccessBoxLunarNewYear',
  props: {
    className: {
      type: String,
      default: 'success-box',
    },
    title: {
      type: String,
      default: '',
    },
    linkEvent: {
      type: String,
      default: 'https://bizflycloud.vn/tin-tuc/tet-giap-thin-nhan-nghin-uu-dai-chiet-khau-30-phi-dich-vu-20240125144127302.htm',
    },
    time: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      dashboardUrl: DASHBOARD,
      timeout: null,
      timer: this.time,
      icon: successful,
    };
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
    ...mapGetters('auth', [
      'callbackUrl', 'ticket', 'twebmail',
    ]),
    redirectUrl() {
      const urlRedirect = this.callbackUrl || this.dashboardUrl;
      let nextUrl = addSearchParams(urlRedirect, { ticket: this.ticket });
      nextUrl = this.twebmail
      ? addSearchParams(nextUrl, { login_param: this.twebmail })
      : nextUrl;
      return nextUrl.href;
    },
  },
  mounted() {
    this.countdownTimer(this.time);
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    countdownTimer(time) {
      this.timer = time || 5;
      this.timeout = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(this.timeout);
          const urlRedirect = this.callbackUrl || this.dashboardUrl;
          let nextUrl = addSearchParams(urlRedirect, { ticket: this.ticket });
          nextUrl = this.twebmail
          ? addSearchParams(nextUrl, { login_param: this.twebmail })
          : nextUrl;
          window.location.href = nextUrl.href;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables';
$iconWidthWrapper: 100%;
$iconWidth: 250px;
$iconPaddingRight: 0;
.button-padding {
  padding: 12px 24px;
    height: 44px;
    display: inline-block;
    margin-top: 40px;
    text-align: center;
}
.inline-icon {
  display: inline;
  vertical-align: middle;
}
.mg-inline {
  margin-right: -2px;
}
.box-label {
  margin-bottom: 40px;
}
.is-tabletpc {
  .box-label {
    flex: $iconWidthWrapper - $iconPaddingRight;
    padding-right: $iconPaddingRight;
    img {
      width: $iconWidth;
      height: $iconWidth;
    }
  }
  .box-content {
    flex: calc(100% - $iconWidth - $gutter - $iconPaddingRight);
}
}
.justify-content-center {
    justify-content: center!important;
    display: flex;
}
</style>
